import React from 'react'

export default function pngFolder(props) {
  const { className, options } = props
  const { ext } = options

  return (
    <div className={className ? className : ''}>
      <svg viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.1"
          d="M30.8299 9.25001V30.95C30.8299 32.63 29.4299 33.94 27.8399 33.94H7.15992C5.47992 33.94 4.16992 32.54 4.16992 30.95V4.76001C4.16992 3.08001 5.47992 1.67001 7.15992 1.67001H23.2499C23.7199 1.67001 24.2799 1.86001 24.5599 2.23001L30.2699 7.84001C30.5499 8.21001 30.8299 8.68001 30.8299 9.24001V9.25001Z"
      className='st1'
        />
        <path
          d="M31.2001 7.33L25.2101 1.53C24.9301 1.16 24.3701 0.970001 23.9001 0.970001H7.07014C5.29014 0.970001 3.89014 2.37 3.89014 4.15V31.47C3.89014 33.25 5.29014 34.65 7.07014 34.65H28.6801C30.4601 34.65 31.8601 33.25 31.8601 31.56V8.92C31.9501 8.27 31.6701 7.7 31.2101 7.33H31.2001ZM30.7301 30.62C30.7301 32.21 29.4201 33.61 27.8301 33.61H7.91014C6.32014 33.61 5.01014 32.3 5.01014 30.62V4.99C5.01014 3.4 6.32014 2 7.91014 2H23.3501C23.8201 2 24.2901 2.19 24.6601 2.56L30.1801 7.99C30.5501 8.36 30.8301 8.93 30.7401 9.49V30.63L30.7301 30.62Z"
          className='st1'
        />
        <path
          d="M2.1202 4.70999H17.7802C18.2902 4.70999 18.7002 5.12999 18.7002 5.66999V11.68C18.7002 12.21 18.2902 12.64 17.7802 12.64H1.2002V5.67999C1.2002 5.14999 1.6102 4.73999 2.1202 4.73999V4.71999V4.70999Z"
          className='st1'
        />
        <path
          d="M18.6301 11.53V11.65C18.6301 12.18 18.2201 12.61 17.7101 12.61H1.14014V5.65C1.14014 5.12 1.55014 4.69 2.06014 4.69H2.54014V7.16C2.54014 9.57 4.41014 11.53 6.74014 11.53H18.6401H18.6301Z"
          className='st2'
  
        />
        <path
          opacity="0.3"
          d="M1.14014 12.61L3.92014 15.88V12.61H1.14014Z"
          className='st2'
        />
        <text
          className='jpg'
          xmlSpace="preserve"
        >
          <tspan x="3" y="10.4656">
            {ext || 'JPEG'}
          </tspan>
        </text>
      </svg>
    </div>
  )
}
